import script from "./PromoPenjualan.vue?vue&type=script&setup=true&lang=js"
export * from "./PromoPenjualan.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__